import React from 'react';

import AllocationGrid from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/BudgetBuilder/BudgetAllocation/AllocationGrid';
import { SearchTextField } from 'src/components/BeaconV2Components/TableSearch';
import { BudgetBuilderSectionHeader } from 'src/components/BeaconV2Components/ExperimentalLayout/Advertising/BudgetBuilder/common';
import { useAppSelector } from 'src/utils/Hooks';
import BudgetSearch from './stores';
import { searchFn } from './utils';

const calculateTopRow = (data: any) => {
  if (!data) {
    return {};
  }
  const mtdSpendSum = data.reduce((acc: number, item: any) => {
    return acc + (item.mtdSpend || 0);
  }, 0);
  const projectedSpendSum = data.reduce((acc: number, item: any) => {
    return acc + (item.projectedSpend || 0);
  }, 0);
  const currentBudgetSum = data.reduce((acc: number, item: any) => {
    return acc + (item?.entity?.extendedAttributes?.liveBudgetSetting?.amount || 0);
  }, 0);
  const newBudgetSum = data.reduce((acc: number, item: any) => {
    return (
      acc +
      (item?.entity?.extendedAttributes?.newBudgetSetting?.amount ||
        item?.entity?.extendedAttributes?.liveBudgetSetting?.amount ||
        0)
    );
  }, 0);

  return {
    isTopRow: true,
    mtdSpendSum,
    projectedSpendSum,
    currentBudgetSum,
    newBudgetSum
  };
};

const ActivePortfolios = ({ data }: { data: any }) => {
  const selectedTimeline = useAppSelector((state) => state.adBudgetEditor.timeline);
  const topRow = calculateTopRow(data);
  const { searchText, setSearchText } = BudgetSearch();

  return (
    <div>
      <BudgetBuilderSectionHeader
        title="Budget Allocation"
        description={`Enter the ${selectedTimeline.monthDisplay} monthly budget allocation for each portfolio below.`}
      />

      <div style={{ marginTop: '32px', marginBottom: '32px' }}>
        <SearchTextField
          placeholder="Search portfolios"
          onSubmit={(e) => {
            e.preventDefault();
          }}
          onChange={(e) => {
            e.preventDefault();
            setSearchText(e.target.value);
          }}
        />
      </div>
      <div
        style={{
          fontSize: 16,
          fontWeight: 700,
          display: 'flex',
          alignItems: 'center'
        }}
      >
        Active Portfolios
      </div>
      <div className="section_body">
        <AllocationGrid
          data={searchFn(searchText, data)}
          entityTableHeaderProps={{
            title: ''
          }}
          topRow={topRow}
        />
      </div>
    </div>
  );
};

export default ActivePortfolios;
